import { Result } from "appworks/model/gameplay/records/results/result";

export default class RespinResult extends Result {

    /** For debugging purposes */
    public resultType: string = "RespinResult";

    public totalRespinsAwarded: number; // Total respins awarded this game
    public respinsAwarded: number; // Respins awarded on this spin
    public respinsRemaining: number;

}
